<template>
  <div>
    <AppSelect
      :value="selectedIds"
      :options="angezeigteOptions"
      :loading="isLoading"
      :internal-search="false"
      text-field="label"
      value-field="id"
      :label="placeholder"
      :placeholder="placeholder"
      multiple
      inline
      empty-text=""
      :no-results-text="`Keine ${objectName} gefunden. Ändere deine Suche`"
      @input="onInput"
      @search-change="onSearchChange"
    />
    <!-- Der Hinweis steht dauerhaft unter dem Feld, nicht erst im geöffneten Panel -->
    <div class="filter-id__banner mt-2">
      <span class="filter-id__banner-icon"><Info :size="16" /></span>
      <span>Mind. {{ startSearchAtLength }} Ziffern der {{ placeholder }} eingeben</span>
    </div>
  </div>
</template>

<script>
import { Info } from 'lucide-vue';

import AppSelect from '@/components/common/app-select/app-select.vue';

export default {
  components: {
    AppSelect,
    Info,
  },
  data() {
    return { selected: null, isLoading: false };
  },
  props: {
    optionsArray: {
      type: Array,
      default: () => {
        return [];
      },
    },
    value: { type: Array, default: () => [] },
    placeholder: { type: String },
    objectName: { type: String },
    startSearchAtLength: { type: String, default: '3' },
    storeFunction: { type: Function },
  },
  computed: {
    selectedIds() {
      return (this.selected ?? []).map(eintrag => eintrag.id);
    },
    angezeigteOptions() {
      const vorhandeneIds = new Set(this.optionsArray.map(option => option.id));
      const fehlende = (this.selected ?? []).filter(eintrag => !vorhandeneIds.has(eintrag.id));
      return fehlende.length ? [...this.optionsArray, ...fehlende] : this.optionsArray;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler: function (v) {
        this.selected = v === null ? [] : v;
      },
    },
  },
  methods: {
    // Setzt die Auswahl aus den Ids wieder zu Objekten zusammen
    // Bereits gewählte Einträge werden behalten, damit sie ohne Suchtreffer nicht verloren gehen
    onInput(ids) {
      this.selected = ids.map(
        id =>
          (this.selected ?? []).find(eintrag => eintrag.id === id) ||
          this.optionsArray.find(option => option.id === id) || { id, label: String(id) }
      );
      this.$emit('input', this.selected);
    },
    onSearchChange(t) {
      if (!this.isLoading) {
        this.isLoading = true;
        this.storeFunction(t).finally(() => {
          this.isLoading = false;
        });
      }
    },
  },
};
</script>

<style scoped>
.filter-id__banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: var(--radius-sm);
  background-color: #eff6ff;
  border: 1px solid #dbeafe;
  font-size: 13px;
  line-height: 20px;
  font-weight: 400;
  color: var(--text-body);
}

.filter-id__banner-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--primary);
}
</style>
